/* eslint-disable */
import { I18N_LANG_AR_AE, I18N_LANG_EN_AU, I18N_LANG_ZH_CN } from '../../Constants/I18n/I18n.constants';
import i18nStore from '../../Support/I18n/Store/I18nStore.support';

/**
 * The `key` to use to store the `translations`
 */
const key = `LogoutPage`;

i18nStore.add(I18N_LANG_AR_AE, key, {
  Goodbye: `تسجيل الخروج`,
  PageHeading: `الخروج`,
  PageTitle: `الخروج`,
});

i18nStore.add(I18N_LANG_EN_AU, key, {
  Goodbye: `Logging you out...`,
  PageHeading: `Logout`,
  PageTitle: `Logout`,
});

i18nStore.add(I18N_LANG_ZH_CN, key, {
  Goodbye: `记录你`,
  PageHeading: `登出`,
  PageTitle: `登出`,
});
